import React from "react";
import Container from 'react-bootstrap/Container';
import {BiLogoGmail, BiLogoLinkedin, BiLogoGithub} from 'react-icons/bi';
import "./Contact.css";

function Contact(){
    return(
        <section id="contact">
            <Container fluid='md'>
                <div className="contact-head">
                    <h1>Contact Me</h1>
                    <hr />
                    <div className="social">
                    <ul className="ul">
                        <li className="">
                            <a href="mailto:ishan06010@gmail.com" target="_blank" rel="noopener noreferrer" className="li-gmail">
                                <BiLogoGmail />
                            </a>
                        </li>
                        <li className="">
                            <a href="https://www.linkedin.com/in/ishan10/" target="_blank" rel="noopener noreferrer" className="li-linkedin">
                                <BiLogoLinkedin />
                            </a>
                            </li>
                        <li className="">
                            <a href="https://github.com/ishan-git-10" target="_blank" rel="noopener noreferrer" className="li-github">
                                <BiLogoGithub />
                            </a>   
                        </li>
                    </ul>
                    </div>
                </div>
                <div className="footer">
                    <h6>Made by Ishan</h6>
                </div>
            </Container>    
        </section>
    );
}

export default Contact;